import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserTokenStore = {
  token: string;
  permissions: string[];
  setToken: (token: string) => void;
  setPermissions: (permissions: string[]) => void;
  clear: () => void;
};

const useUserTokenStore = create(
  persist<UserTokenStore>(
    (set) => ({
      token: "",
      permissions: [],
      setToken: (token) => set({ token }),
      setPermissions: (permissions) => set({ permissions }),
      clear: () => set({ token: "", permissions: [] }),
    }),
    {
      name: "user-token",
    }
  )
);

export default useUserTokenStore;
